import { BookOpen, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import { categoryGuide } from "../lib/categoryGuides.mjs";
import FaqAccordion from "./FaqAccordion";

function StockCompareTable({ guide }) {
  if (!guide.compare?.length) return null;
  return (
    <section className="card-base p-6 lg:p-8 mt-6" data-testid="category-stock-compare">
      <div className="overline mb-2">Material comparison</div>
      <h2 className="font-display font-black text-2xl text-kolt-slate-dark tracking-tight">{guide.compareTitle}</h2>
      {guide.compareIntro && <p className="text-slate-600 text-sm md:text-base mt-2 max-w-3xl">{guide.compareIntro}</p>}
      {guide.compareArticle && <Link to={guide.compareArticle.href} className="inline-block mt-2 text-sm font-semibold text-[#DD6B33] hover:underline" data-testid="category-compare-article-link">{guide.compareArticle.text} →</Link>}
      <div className="overflow-x-auto mt-5">
        <table className="w-full text-sm min-w-[760px]">
          <thead>
            <tr className="text-[10px] font-mono uppercase tracking-widest text-slate-500 text-left border-y border-slate-200">
              <th className="py-2 pr-3">Stock</th><th className="py-2 pr-3">Best for</th><th className="py-2 pr-3">Durability</th><th className="py-2 pr-3">Finishes</th><th className="py-2 text-right">Price</th>
            </tr>
          </thead>
          <tbody>
            {guide.compare.map((r) => (
              <tr key={r.stock} className="border-b border-slate-100 hover:bg-slate-50 transition-colors duration-150" data-testid={`category-compare-row-${r.href.split("/").pop()}`}>
                <td className="py-2.5 pr-3 font-bold text-kolt-slate-dark"><Link to={r.href} className="hover:text-[#DD6B33]">{r.stock}</Link></td>
                <td className="py-2.5 pr-3 text-slate-600">{r.bestFor}</td>
                <td className="py-2.5 pr-3 text-slate-600">{r.durability}</td>
                <td className="py-2.5 pr-3 text-slate-600">{r.finishes}</td>
                <td className="py-2.5 text-right font-mono text-slate-700 whitespace-nowrap">{r.price}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export function CategoryBuyerGuide({ categorySlug }) {
  const guide = categoryGuide(categorySlug);
  if (!guide) return null;
  return (
    <>
      <section className="card-base p-6 lg:p-8 mt-10" data-testid="category-buyer-guide">
        <div className="overline mb-2 flex items-center gap-2"><BookOpen className="w-3.5 h-3.5 text-[#DD6B33]" /> Buyer's guide</div>
        <h2 className="font-display font-black text-2xl text-kolt-slate-dark tracking-tight">{guide.title}</h2>
        <div className="grid lg:grid-cols-3 gap-8 mt-5">
          <div className="lg:col-span-2 space-y-4">
            {guide.paragraphs.map((p, i) => <p key={i} className="text-slate-700 leading-relaxed text-sm md:text-base">{p}</p>)}
          </div>
          <ul className="space-y-3 border-l border-slate-200 pl-6 self-start">
            {guide.tips.map((t) => (
              <li key={t} className="flex gap-2 text-sm text-slate-700"><CheckCircle2 className="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" /> {t}</li>
            ))}
          </ul>
        </div>
      </section>
      <StockCompareTable guide={guide} />
      {guide.faqs?.length > 0 && <div className="mt-6" data-testid="category-faq"><FaqAccordion items={guide.faqs} heading="Label stock questions, answered" /></div>}
    </>
  );
}
